module.exports = __webpack_public_path__ + "media/Loops 90 Bass.1e88542c.wav";